export default function (app) {
  return {
    state: {
      siderCollapsed: false,
    },
    getters: {

    },
    actions: {
      toggleSiderCollapsed: ({ commit, state: { siderCollapsed, }, }) => commit('setSiderCollapsed', !siderCollapsed),
    },
    mutations: {
      setSiderCollapsed: (state,value) => state.siderCollapsed = value,
    },
  };
}
